import * as React from 'react';

interface IUseRange {
  count: number;
}

export const useRange = (args: IUseRange) => {
  const [items, setItems] = React.useState<Array<number>>([]);

  const init = () => {
    const arr = [];
    for (let i = 0; i < args.count; i++) {
      arr.push(i);
    }
    setItems(arr);
  };

  React.useEffect(() => {
    init();
  }, [args.count]);

  return { items };
};
